import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SalvageExchangeProvider } from '..';
import { PaginatedResponse } from 'src/app/models/api-response.model';

// Interface for the actual API response structure
interface SalvageExchangeProvidersApiResponse {
  count: number;
  result: SalvageExchangeProvider[];
}

@Injectable({ providedIn: 'root' })
export class CustomisationSalvageExchangeService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}`;

  get(): Observable<PaginatedResponse<SalvageExchangeProvider>> {
    return this.http
      .get<SalvageExchangeProvidersApiResponse>(
        `${this.baseUrl}/tenants/settings/salvage-exchange/providers`
      )
      .pipe(
        map((response) => {
          return {
            items: response.result,
            total: response.count,
            page: 1,
            pageSize: response.count,
          };
        })
      );
  }
}
